import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Input = React.forwardRef((props, ref) => {
  const {
    className: additionalClassName,
    tag: Tag,
    type,
    withBorder,
    error,
    requiredStyle,
    ...otherProps
  } = props;

  const className = classNames('input', {
    'input_with-border': withBorder,
    input_required: requiredStyle,
    input_invalid: error,
  });

  const innerClassName = classNames('input__inner', additionalClassName);

  return (
    <div className={className}>
      <Tag className={innerClassName} type={type} {...otherProps} ref={ref} />
      {error && <span className="input__error">{error}</span>}
    </div>
  );
});

Input.defaultProps = {
  className: null,
  tag: 'input',
  type: 'text',
  withBorder: false,
  error: null,
  requiredStyle: false,
};

Input.propTypes = {
  className: PropTypes.string,
  tag: PropTypes.oneOf(['input', 'textarea']),
  type: PropTypes.string,
  withBorder: PropTypes.bool,
  error: PropTypes.string,
  requiredStyle: PropTypes.bool,
};

export default Input;
